import { axios } from "../axios"

export const apiCustomers = {
    getAllCustomers: () => axios.get(`/customers?populate=*`)
}